import React from "react";
import GridCard from "./GridCard";

interface Props {
  data?: string[][];
  loading: boolean;
}

const AuthorizationCard: React.FC<Props> = ({ data, loading }) => {
  if (!data || data.length === 0) return null;

  return (
    <GridCard
      title="Authorization Data by Role"
      headers={[
        "Client Name",
        "Analyst Authorized Hours",
        "Analyst Provided Hours",
        "RBT - Assistant - Student Analyst Hours Authorized",
        "RBT - Assistant - Student Analyst Hours Provided",
        "RBT - Assistant - Student Analyst Provided Percent",
      ]}
      data={data}
      loading={loading}
    />
  );
};

export default AuthorizationCard;